import * as React from "react";
import { Table } from "soprasteria-ui-library";
import { IOrthodonticReferralAdvancedConsultationNeed } from "../../../models/IOrthodonticReferral";
import { Link } from "react-router-dom";
import { ORTHODONTIC_REFERRAL, PATIENT } from "../../../utils/RouteConstants";
import { dateTimeToDateString } from "../../../helpers/DateHelper";

interface IOrthodonticReferralAdvancedConsultationNeedsForConsultationDentalGroupTable {
    orthodonticReferralAdvancedConsultationNeeds: IOrthodonticReferralAdvancedConsultationNeed[];
}

export const OrthodonticReferralAdvancedConsultationNeedsForConsultationDentalGroupTable: React.FunctionComponent<IOrthodonticReferralAdvancedConsultationNeedsForConsultationDentalGroupTable> = ({ orthodonticReferralAdvancedConsultationNeeds }) => {

    const renderTableLink = (orthodonticReferralId: number, patientGuidId: string, linkText: string) => {
        return <Link to={`${PATIENT}/${patientGuidId}/${ORTHODONTIC_REFERRAL}/${orthodonticReferralId}`}>{linkText}</Link>
    }

    return (
        <Table hoverableRows>
            <thead>
                <tr>
                    <th>Skickad</th>
                    <th>Remiss-ID</th>
                    <th>Vårdgivare</th>
                    <th>Mottagning</th>
                    <th>Anledning</th>
                    <th>Motivering</th>
                </tr>
            </thead>
            <tbody>
                {
                    orthodonticReferralAdvancedConsultationNeeds.length > 0 ?
                        orthodonticReferralAdvancedConsultationNeeds.map((need, key) =>
                            <tr key={key} className="clickable-row">
                                <td className="text-nowrap table-data-link">{renderTableLink(need.orthodonticReferralId, need.patientGuidId, dateTimeToDateString(need.regDate))}</td>
                                <td className="table-data-link">{renderTableLink(need.orthodonticReferralId, need.patientGuidId, need.orthodonticReferralNumber)}</td>
                                <td className="text-nowrap table-data-link">{renderTableLink(need.orthodonticReferralId, need.patientGuidId, need.careProvider.displayOrganisationInformation ?? "")}</td>
                                <td className="text-nowrap table-data-link">{renderTableLink(need.orthodonticReferralId, need.patientGuidId, need.careProvider.displayCareProviderName ?? "")}</td>
                                <td className="table-data-link">{renderTableLink(need.orthodonticReferralId, need.patientGuidId, need.orthodonticReferralAdvancedConsultationNeedReason)}</td>
                                <td className="table-data-link" style={{ whiteSpace: "pre-line", wordBreak: "break-word" }}>{renderTableLink(need.orthodonticReferralId, need.patientGuidId, need.motivation)}</td>
                            </tr>
                        )
                        : <tr><td colSpan={6}>Det finns inga ortodontiremisser som skickats till urvalstandläkargruppen</td></tr>
                }
            </tbody>
        </Table>
    )
}